import jwtDecode from 'jwt-decode';
import { useHistory } from 'react-router-dom';

export const TOKEN_KEY = '@Token';
export const DATA_PERFIL = '@dados-Perfil';

export const isAuthenticated = () => {
  if (localStorage.getItem(TOKEN_KEY) !== null) {
    // verifica se o objeto esta vazio
    const verificaPerfilVazio = Object.entries(
      JSON.parse(localStorage.getItem(DATA_PERFIL))
    ).length;

    if (verificaPerfilVazio === 0) {
      logout();
    }

    return true;
  } else {
    return false;
  }
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const login = (token, perfil) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(DATA_PERFIL, JSON.stringify(perfil));
  // #133: o token recém-emitido é a verdade do momento; a cópia local pode ser
  // de outra conta que usou este navegador.
  limpaAcessos();
};

export const getData = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  return jwtDecode(token);
};

// #133: a lista de permissões vinha de dentro do JWT, que só muda quando o
// usuário desloga e loga de novo. Agora há uma cópia local, atualizada pelo
// services/acessos.js a partir de GET /meus-acessos.
//
// Este arquivo NÃO importa services/api.js de propósito: api.js já importa
// daqui (getToken, logout), e o import de volta fecharia um ciclo.
export const ACESSOS_KEY = '@Acessos';

const TTL_ACESSOS_MS = 60 * 1000;

export const salvaAcessos = acessos => {
  localStorage.setItem(
    ACESSOS_KEY,
    JSON.stringify({ acessos, buscadoEm: Date.now() })
  );
};

export const limpaAcessos = () => localStorage.removeItem(ACESSOS_KEY);

const leCopiaLocal = () => {
  try {
    const bruto = JSON.parse(localStorage.getItem(ACESSOS_KEY));
    if (bruto && Array.isArray(bruto.acessos)) return bruto;
  } catch (e) {
    // JSON corrompido: trata como ausente.
  }
  return null;
};

// Fonte única de permissão no front. Cai para o JWT quando ainda não há cópia
// local — sessão aberta antes deste deploy, ou primeira navegação após o login.
export const getAcessos = () => {
  const copia = leCopiaLocal();
  if (copia) return copia.acessos;

  try {
    const dados = jwtDecode(localStorage.getItem(TOKEN_KEY));
    return Array.isArray(dados.acessos) ? dados.acessos : [];
  } catch (e) {
    return [];
  }
};

export const acessosEstaoStale = () => {
  const copia = leCopiaLocal();
  if (!copia) return true;
  return Date.now() - copia.buscadoEm > TTL_ACESSOS_MS;
};

export const getPerfil = () => {
  const perfil = JSON.parse(localStorage.getItem(DATA_PERFIL));
  return perfil;
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(DATA_PERFIL);
  limpaAcessos();
};

export const permissaoDeRota = rota => {
  const acessos = getAcessos();
  return acessos.find(t => t.rota === rota) !== undefined;
};
// export const getRoutes = () => {

// }
